import React from 'react';
import PropTypes from 'prop-types';
import { Container } from '../../base';
import { HeroLandingWrapper, HeroLandingImage, HeroLandingImageMobile } from './Styled';

const HeroLanding = ({ title }) => (
  <HeroLandingWrapper>
    <Container>
      <h1>{title}</h1>
    </Container>
    <HeroLandingImage>
      <img src="../../../../static/images/illustrations/hero-landing.svg" alt="Hero - Landing" />
    </HeroLandingImage>
    <HeroLandingImageMobile>
      <img src="../../../../static/images/illustrations/hero-landing-mobile.svg" alt="Hero - Landing" />
    </HeroLandingImageMobile>
  </HeroLandingWrapper>
);

HeroLanding.propTypes = {
  title: PropTypes.string,
};

export default HeroLanding;
